import { Pipe, PipeTransform } from '@angular/core';
import { Color } from '@shared/enums';

@Pipe({
  name: 'colorClass',
  standalone: true,
})
export class ColorClassPipe implements PipeTransform {
  transform(color: keyof typeof Color): string {
    return `color-${color ? color.toLowerCase() : Color.BLACK}`;
  }
}
